import { WebToolItem } from '../models/web-tool-item';

function compare(a: WebToolItem, b: WebToolItem) {
  return a.name > b.name ? 1 : a.name < b.name ? -1 : 0;
}

export function sortByName(items: WebToolItem[]) {
  return items.sort(compare);
}
